<template>
	<div class="page">
		<!-- your page -->
		<div class="password">
			<div class="title">
				密码修改
			</div>
			<div class="line">
				<div class="lineTitle">新密码:&nbsp;</div>
				<div class="inputBox"><input type="passwprd" placeholder="请输入新密码" v-model="password"></div>
			</div>
			<div class="line">
				<div class="lineTitle">确认密码:&nbsp;</div>
				<div class="inputBox"><input type="passwprd" placeholder="请确认新密码" v-model="rptPwd"></div>
			</div>
			<div class="line">
				<div class="lineTitle">绑定的手机号:&nbsp;</div>
				<div class="inputBox"><input type="number" placeholder="请输入绑定的手机号" v-model="phone"></div>
			</div>
			<div class="line">
				<div class="lineTitle">验证码:&nbsp;</div>
				<div class="inputBox code"><input type="number" placeholder="请输入短信验证码" v-model="code"><button class="send" @click="sendCode" v-show="sendShow">发送验证码</button><button v-show="!sendShow" class="noSend">{{second}}s后可重发</button></div>
			</div>
			<div class="line">
				<div class="lineTitle"></div>
				<div class="inputBox"><button class="enterBtn" @click="enter">确定</button></div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'changePass',
		data(){
			return {
				password:"",
				phone:"",
				code:"",
				rptPwd:"",
				sendShow:true,
				second:60
			}
		},
		methods:{
			sendCode(){
				var data = {
					mobile: this.phone,
					code: "veri",
					method: "user.sms"
				}
				if(this.phone.length!=11){
					this.globalTest('user.sms','error','请输入正确的手机号')
					return
				}
				this.sendShow = false
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('user.sms','success','获取验证码成功')
						var interVal = setInterval(function(){
							var second = that.second
							if(second>0){
								second--
								that.second = second
							}else{
								clearInterval(interVal)
								that.sendShow = true
							}
						},1000)
					}else{
						that.globalTest('user.sms','error',res.msg,res.data)
					}
				})
			},
			enter(){
				var data = {
					mobile: this.phone,
					code: this.code,
					newpwd: this.password,
					repwd: this.rptPwd,
					token: this.token,
					method: "user.forgotpwd"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('user.forgotpwd','success','重置密码成功，请重新登录')
						localStorage.clear()
						that.$router.push({path:'/login',query:{type:1}})
					}else{
						that.globalTest('user.forgotpwd','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.password{
		width: 100%;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.title{
		width: 100%;
		height: 50px;
		line-height: 60px;
		border-bottom: 1px solid #C3C3C3;
	}
	.line{
		width: 100%;
		height: 60px;
		position: relative;
		line-height: 60px;
	}
	.lineTitle{
		width: 120px;
		height: 100%;
		position: absolute;
		left: 0px;
		right: 0px;
		text-align: right;
	}
	.inputBox{
		width: 100%;
		height: 100%;
		padding-left: 125px;
		box-sizing: border-box;
	}
	.inputBox input{
		width: 300px;
		height: 30px;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		display: block;
		margin-top: 15px;
		float: left;
	}
	.code input{
		width: 220px;
	}
	.send,.noSend{
		width: 80px;
		height: 30px;
		float: left;
		margin-top: 15px;
		border: none;
		background: none;
		font-size: 12px;
		color: #036DEE;
	}
	.noSend{
		color: #838383;
	}
	.enterBtn{
		width: 100px;
		height: 30px;
		background: #036DEE;
		margin-top: 15px;
		border: none;
		color: #FFFFFF;
	}
</style>
